import React from 'react';
import { Project } from 'utility/interfaces';
import { AiOutlineStock } from 'react-icons/ai';
import { TbAnalyze } from 'react-icons/tb';
import { TfiWrite } from 'react-icons/tfi';
import { GiButterflyKnife } from 'react-icons/gi';

export const projects: Project[] = [
    {
        title: 'rewardable.io',
        icon: 'https://firebasestorage.googleapis.com/v0/b/referable-63835.appspot.com/o/logo.webp?alt=media&token=31905f3f-713f-4b50-ba61-90c639fb7826',
        color: 'blue',
        link: 'https://www.rewardable.io/',
        icons: [
            {
                icon: 'wrench',
                text: 'Work in progress',
            },
        ],
    },

    {
        title: 'pitchpower.ai',
        icon: 'https://firebasestorage.googleapis.com/v0/b/proposaly-a45f6.appspot.com/o/pitchpower-logo.svg?alt=media&token=cf3be78d-eb7f-4bf7-ac94-21a395010282',
        color: 'green',
        link: 'https://www.pitchpower.ai/',
        icons: [
            {
                icon: 'user',
                text: '5K+ Users',
            },
        ],
    },
    {
        title: 'writemore.io',
        icon: 'https://firebasestorage.googleapis.com/v0/b/writemore-e01cc.appspot.com/o/logo-light-no-words%20(1).svg?alt=media&token=8439287d-261c-4256-8456-afe0544ddfe5',
        color: 'blue',
        link: 'https://writemore.io/',
        icons: [
            {
                icon: 'user',
                text: '4K+ Users',
            },
        ],
    },
    {
        title: 'knifegeek.io',
        icon: 'https://firebasestorage.googleapis.com/v0/b/writemore-e01cc.appspot.com/o/FJ%20(2).png?alt=media&token=8863344d-45d6-426f-8453-a30d570759b1',
        color: 'blue',
        link: 'https://www.knifegeek.io/',
        icons: [
            {
                icon: 'eye',
                text: '10K+ MAU',
            },
        ],
    },
    {
        title: 'stockalarm.io (*acquired)',
        icon: 'https://firebasestorage.googleapis.com/v0/b/writemore-e01cc.appspot.com/o/stock-alarm.webp?alt=media&token=a5f573a3-7b9c-4121-8133-6dbcd4e52663',
        color: 'blue',
        link: 'https://stockalarm.io/',
        icons: [
            {
                icon: 'user',
                text: '200K+ Users',
            },
        ],
    },
    {
        title: 'essense.io (*acquired)',
        icon: 'https://firebasestorage.googleapis.com/v0/b/writemore-e01cc.appspot.com/o/bottle%20(1).png?alt=media&token=a37b1164-9b79-4406-b050-a6f76954f0d3',
        color: 'blue',
        link: 'https://essense.io/',
    },
];
